import { PropsWithChildren } from 'react';

import styles from '../../WizardLayout.module.scss';

export const RightPanel = ({ children }: PropsWithChildren) => {
  return <aside className={styles.rightPanel}>{children}</aside>;
};
